import { Component } from 'react';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import UISelect from 'UIComponents/input/UISelect';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import H2 from 'UIComponents/elements/headings/H2';
import { DEFAULT_BRANCH_INDEX } from 'automation-ui-action-features/records/recordsUtils';
import StaticBranchName from 'automation-ui-action-features/actions/static-branch/StaticBranchName';
import { getCleanedConnections } from 'automation-ui-canvas/components/canvas/copyPaste/getCleanedConnections';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class PasteBranchModal extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      removeAllChildren: false,
      // we need to effectively not pass a value for branchIndexToKeep when a branch is not selected
      branchIndexToKeep: undefined,
      // we need to effectively not pass a value for parentBranchIndex when a branch is not selected or is invalid/not an option
      parentBranchIndex: undefined
    };
    this.handleSave = () => {
      return this.props.onSave(this.state);
    };
    this.setRemoveAllChildren = () => {
      this.setState({
        removeAllChildren: true,
        branchIndexToKeep: undefined
      });
    };
    this.getBranchName = (branch, branchIndex, action) => {
      const {
        previousActionId,
        flowObjectTypeId,
        getActionOutputsForTargetActionById
      } = this.props;
      if (action && action.isStaticBranch()) {
        return /*#__PURE__*/_jsx(StaticBranchName, {
          action: action,
          previousActionId: previousActionId,
          branch: branch,
          branchIndex: branchIndex,
          propertyTypeId: flowObjectTypeId,
          getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
        });
      }
      const defaultValue = I18n.text('action-features.list-branch.branch-label.default', {
        branchNumber: branchIndex + 1
      });
      const branchName = branch.getBranchName() || defaultValue;
      return branchName;
    };
    this.handleOnBranchChange = ({
      target: {
        value
      }
    }) => {
      this.setState({
        removeAllChildren: false,
        branchIndexToKeep: value
      });
    };
    this.handleOnParentBranchIndexChange = ({
      target: {
        value: parentBranchIndex
      }
    }) => {
      this.setState({
        parentBranchIndex
      });
    };
    this.isSaveModalValid = () => {
      const {
        removeAllChildren,
        branchIndexToKeep,
        parentBranchIndex
      } = this.state;
      const {
        parentAction,
        action
      } = this.props;
      const isParentBranchSelectionValid = parentAction && parentAction.isBranch() ? Number.isInteger(parentBranchIndex) : true;
      const isTargetBranchValid = action.isBranch() ? removeAllChildren || Number.isInteger(branchIndexToKeep) : true;
      return isParentBranchSelectionValid && isTargetBranchValid;
    };
  }
  getBranchNameOptions(action) {
    if (!action.isBranch()) {
      return [];
    }
    const connection = getCleanedConnections(action);
    const branches = connection.getBranches();
    const defaultBranchName = connection.getDefaultBranchName();
    const defaultBranchOption = {
      text: defaultBranchName || I18n.text('action-features.list-branch.branch-label.otherwiseDefaultBranchName'),
      value: DEFAULT_BRANCH_INDEX
    };
    const branchOptions = branches.map((branch, branchIndex) => ({
      text: this.getBranchName(branch, branchIndex, action),
      value: branchIndex
    })).toJS();
    return [...branchOptions, defaultBranchOption];
  }
  render() {
    const {
      onClose,
      action,
      parentAction
    } = this.props;
    const {
      removeAllChildren,
      branchIndexToKeep,
      parentBranchIndex
    } = this.state;
    return /*#__PURE__*/_jsxs(UIModal, {
      width: 550,
      "data-test-id": "insert-or-remove-branch-modal",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "edit.pasteBranchModal.header"
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [parentAction && parentAction.isBranch() && /*#__PURE__*/_jsx(UIFormControl, {
          className: "m-bottom-2",
          label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "edit.pasteBranchModal.rootOptionsPrompt"
          }),
          children: /*#__PURE__*/_jsx(UISelect, {
            value: parentBranchIndex,
            options: this.getBranchNameOptions(parentAction),
            placeholder: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "edit.pasteBranchModal.placeholderBranchName"
            }),
            onChange: this.handleOnParentBranchIndexChange,
            className: "m-top-2"
          })
        }), action.isBranch() && /*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "edit.pasteBranchModal.optionsPrompt"
          }),
          children: /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsxs(UIList, {
              className: "m-top-2",
              children: [/*#__PURE__*/_jsx(UIRadioInput, {
                checked: removeAllChildren,
                name: "branch-type",
                onChange: this.setRemoveAllChildren,
                "data-test-id": "remove-branch-all",
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: "edit.pasteBranchModal.removeAll"
                })
              }), /*#__PURE__*/_jsxs(UIRadioInput, {
                checked: branchIndexToKeep !== undefined,
                name: "branch-select",
                onChange: () => this.handleOnBranchChange(syntheticEvent(-1)),
                children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: "edit.pasteBranchModal.executeABranch"
                }), /*#__PURE__*/_jsx(UISelect, {
                  value: branchIndexToKeep,
                  options: this.getBranchNameOptions(action),
                  placeholder: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                    message: "edit.pasteBranchModal.placeholderBranchName"
                  }),
                  onChange: this.handleOnBranchChange,
                  className: "m-top-2"
                })]
              })]
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          type: "submit",
          disabled: !this.isSaveModalValid(),
          onClick: this.handleSave,
          "data-test-id": "remove-branch-ok",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "edit.pasteBranchModal.removeButton"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "secondary",
          type: "submit",
          onClick: onClose,
          "data-test-id": "remove-branch-cancel",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "edit.cancel"
          })
        })]
      })]
    });
  }
}
export default PasteBranchModal;